import { JsonObject, JsonProperty } from 'json2typescript';
import { Entity } from './entity';

@JsonObject('SalesOrderFilter')
export class SalesOrderFilter extends Entity {
  @JsonProperty('accountName', [String])
  public accountName: string[] = [];
  @JsonProperty('serialNumbers', [String])
  public serialNumbers: string[] = [];

  @JsonProperty('orderBy', [String])
  public orderBy: string[] = [];
  @JsonProperty('direction', [String])
  public direction: string[] = [];
}
